document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll('.customer-reviews__load-more');

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.getAttribute('data-target');
      var grid = targetId ? document.getElementById(targetId) : null;
      if (!grid) return;

      var hiddenCards = grid.querySelectorAll('.review-card--hidden');
      hiddenCards.forEach(function (card) {
        card.classList.remove('review-card--hidden');
        card.removeAttribute('aria-hidden');
      });

      btn.setAttribute('hidden', 'hidden');
    });
  });
});
